import http from './http';
import { listResource } from './listResource';

export async function listModalities(options = {}) {
  return listResource('/modalities', options);
}

/**
 * Obtiene un modalidad por su ID.
 */
export async function getModalityById(id) {
  const res = await http.get(`/modalities/${id}`);
  return res.data?.data ?? res.data;
}

/**
 * Revisar que no este en uso la modalidad o el código.
 */
export async function checkModalityExists(title, excludeId = null) {
  try {
    const { items } = await listModalities({ search: title });
    const exists = items?.some(
      (modality) =>
        (modality.description?.toLowerCase() === title?.toLowerCase() ||
          modality.code?.toLowerCase() === title?.toLowerCase()) &&
        modality.id !== Number(excludeId),
    );
    return exists;
  } catch (error) {
    console.error('Error al verificar la modalidad:', error);
    return false;
  }
}
/**
 * Revisar que no este en uso el orden
 */
export async function checkModalityOrderExists(order, excludeId = null) {
  try {
    const { items } = await listModalities({ search: order });
    const exists = items?.some(
      (modality) =>
        modality.order === order && modality.id !== Number(excludeId),
    );
    return exists;
  } catch (error) {
    console.error('Error al verificar el orden:', error);
    return false;
  }
}

/**
 * Actualiza un modalidad.
 */
export async function updateModality(id, userData) {
  const res = await http.put(`/modalities/${id}`, userData);
  return res.data?.data ?? res.data;
}

/**
 * Crear un modalidad.
 */
export async function createModality(userData) {
  const res = await http.post(`/modalities/`, userData);
  return res.data?.data ?? res.data;
}

/**
 * Activar/Desactivar modalidad
 */
export const updateModalityStatus = (id, isActive) =>
  // eslint-disable-next-line camelcase
  http.patch(`/modalities/status/${id}`, { is_active: isActive });

/**
 * Eliminar modalidad
 */
export const deleteModality = (id) => http.delete(`/modalities/${id}`);

export async function uploadModalityMedia(file) {
  const formData = new FormData();
  formData.append('file', file);

  const res = await http.post('/files/upload/modality', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  const responseData = res.data?.data ?? res.data;
  return {
    url: responseData?.url ?? responseData,
    preview_url: responseData?.preview_url ?? null,
  };
}
